var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"display-1 font-weight-bold mt-3 mb-2"},[_vm._v(_vm._s(_vm.i18n.title))]),_c('div',{staticClass:"product-details",domProps:{"innerHTML":_vm._s(_vm.context)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }